import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Login as BLLogin } from './../../../utilities/BL/Login'


const Login = () => {
    const navigate = useNavigate()
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    // Función principal para iniciar sesión
    const handleLogin = async () => {
        try {
            setError(null)
            setIsLoading(true)

            // Validaciones básicas antes de enviar
            if (!username.trim()) {
                setError('Escribe tu usuario')
                return
            }

            if (!password.trim()) {
                setError('Escribe tu contraseña')
                return
            }

            // Llamar a la capa BL pasando usuario y contraseña
            const response = await BLLogin(username, password)

            if (response.success) {
                const role = (response.data?.role || localStorage.getItem('role') || '').toLowerCase();
                try {
                    localStorage.setItem('role', role);
                } catch {}

                if (role === 'sound_operator') {
                    navigate('/admin/playlist/cabina');
                } else {
                    navigate('/admin/dashboard');
                }
            } else {
                setError(response.message || 'Usuario o contraseña incorrectos')
            }
        } catch (err) {
            console.error(err)
            setError('Ha habido un error al intentar iniciar sesión. Inténtalo nuevamente más tarde.')
        } finally {
            setIsLoading(false)
        }
    }

    // Detectar tecla Enter en el formulario
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault() // evita que el form recargue la página
            handleLogin()
        }
    }


    return (
        <main className="container Login">
            <div className="row Login__Container">
                <div className="row">
                    <img src="/img/page/adsl-five-bicolor.png" className="LogoADSLxZtudia" alt="Logo" />

                    <h1 className="mt-2 text-center fs-4">Iniciar sesión</h1>

                    <form className="mt-4" onKeyDown={handleKeyDown}>
                        <div className="mb-3">
                            <input
                                type="text"
                                className="form-control"
                                id="txtUser"
                                placeholder="Usuario"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                autoComplete="username"
                            />
                        </div>

                        <div className="mb-3">
                            <input
                                type="password"
                                className="form-control"
                                id="txtPassword"
                                placeholder="Contraseña"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                autoComplete="current-password"
                            />
                        </div>

                        <button type="button" className="Btn__Adsl--Red" onClick={handleLogin} disabled={isLoading}>
                            {isLoading ? 'Iniciando...' : 'Iniciar sesión'}
                        </button>

                        {error && error !== '' && (
                            <p className="text-center text-danger mt-3">{error}</p>
                        )}
                    </form>
                </div>
            </div>
        </main>
    )
}

export { Login };









// import { useNavigate } from 'react-router-dom'


// const Login = () => {
//     const navigate = useNavigate()


//     return (
//         <main className="container Login">
//             <div className="row Login__Container">
//                 <div className="row">
//                     {/* <img src="/img/brand/logotipo-adsl.png" className="LogoADSL" /> */}
//                     <img src="/img/page/adsl-five-bicolor.png" className="LogoADSLxZtudia" alt="Logo" />

//                     <h1 className="mt-2 text-center fs-4">Iniciar sesión</h1>

//                     <form className="mt-4">
//                         <div className="mb-3">
//                             <input type="text" className="form-control" id="txtUser" placeholder='Usuario' />
//                         </div>

//                         <div className="mb-3">
//                             <input type="password" className="form-control" id="txtPassword" placeholder='Contraseña' />
//                         </div>
                        
//                         <button type="button" className="Btn__Adsl--Red" onClick={() => navigate('/admin/dashboard')}>Iniciar sesión</button>
//                     </form>
//                 </div>
//             </div>
//         </main>
//     )
// }

// export { Login };